'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelink = function MdPhonelink(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.6 28.4v-11.8h-6.6v11.8h6.6z m1.8-15c0.9 0 1.6 0.7 1.6 1.6v16.6c0 1-0.7 1.8-1.6 1.8h-10c-1 0-1.8-0.8-1.8-1.8v-16.6c0-0.9 0.8-1.6 1.8-1.6h10z m-31.8-3.4v18.4h16.8v5h-23.4v-5h3.4v-18.4c0-1.8 1.4-3.4 3.2-3.4h30v3.4h-30z' })
        )
    );
};

exports.default = MdPhonelink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink.js
// module id = 3169
// module chunks = 0